import React, { useEffect, useState } from "react";
import { Container, Table, Form, Pagination, Offcanvas, } from "react-bootstrap";
import {
  FiEdit, FiTrash2, FiPlus, FiFilter, FiDownload, FiHome,
  FiChevronRight,
} from "react-icons/fi";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStudent, deleteStudent } from "../../store/slices/student";

export default function StudentsList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [studentsdata, setStudentsdata] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(25);


  const getFiltersFromUrl = () => ({
    standardId: searchParams.get("standardId") || "",
    sectionId: searchParams.get("sectionId") || "",
  });

  const [filters, setFilters] = useState(getFiltersFromUrl);

  const [standardId, setStandardId] = useState(
    searchParams.get("standardId") || ""
  );

  const [sectionId, setSectionId] = useState(
    searchParams.get("sectionId") || ""
  );

  const currentPage =
    Number(searchParams.get("page")) || 1;

  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  const [standardList, setStandardList] = useState([]);

  const [showFilter, setShowFilter] = useState(false);

  const fetchStudents = (page = 1, filterData = {}) => {
    setIsLoading(true);

    dispatch(
      getStudent({
        page,
        limit: itemsPerPage,
        ...filterData,
      })
    )
      .unwrap()
      .then((res) => {
        setStudentsdata(res.data || []);
        setTotalData(res.totalDataCount || 0);
      })
      .catch(() => {
        toast.error("Failed to fetch students");
        setStudentsdata([]);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    const filterData = {
      standardId: searchParams.get("standardId") || "",
      sectionId: searchParams.get("sectionId") || "",
    };

    setFilters(filterData);
    setStandardId(filterData.standardId);
    setSectionId(filterData.sectionId);

    fetchStudents(currentPage, filterData);
  }, [searchParams, currentPage]);


  useEffect(() => {
    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {
        const normalized = (res?.data || []).map((item) => ({
          _id: item.standardId?._id,
          name: item.standardId?.name,
          sections: item.sectionId || [],
        }));
        setStandardList(normalized);
      })
      .catch(() => toast.error("Failed to fetch standard & section"));
  }, []);

  const handleFilter = () => {
    if (!standardId) {
      toast.error("Please select standard");
      return;
    }

    const appliedFilters = {
      standardId,
      sectionId,
    };

    setFilters(appliedFilters);

    const params = {
      page: 1,
      standardId,
    };

    if (sectionId) {
      params.sectionId = sectionId;
    }

    setSearchParams(params);

    setShowFilter(false);
  };

  const handleClear = () => {
    setStandardId("");
    setSectionId("");

    setFilters({
      standardId: "",
      sectionId: "",
    });

    setSearchParams({
      page: 1,
    });

    setShowFilter(false);
  };

  /*  export CSV < ---------- */
  const handleExport = () => {
    if (studentsdata.length === 0) {
      toast.error("No data to export");
      return;
    }

    const headers = [
      "Name",
      "Standard",
      "Section",
      "Gender",
      "DOB",
      "Father Name",
      "Father Mobile",
    ];

    const rows = studentsdata.map((s) => [
      s.name,
      s.standardId?.name,
      s.sectionId?.name,
      s.gender,
      s.dob?.slice(0, 10),
      s.parentId?.fatherName,
      s.parentId?.fatherMobileNo,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = csvContent;
    link.download = "students_list.xlsx";
    link.click();
  };


  // pagination <--------
  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = studentsdata;

  const handleDeleteRow = async (studentId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this student?"
    );

    if (!confirmed) {
      return;
    }

    try {
      await dispatch(deleteStudent(studentId)).unwrap();

      toast.success("Student deleted successfully");

      // Refresh current page after delete
      fetchStudents(currentPage, filters);

    } catch (error) {
      toast.error(error || "Failed to delete student");
    }
  };


  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />

            <span className="active">Students</span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <button
              className="btn-cancel  gap-2"
              onClick={() => setShowFilter(true)}

            >
              <FiFilter />
              Filters
            </button>

            <button
              className="btn-submit gap-2"
              onClick={handleExport}
            >
              <FiDownload />
              Export
            </button>
            <Link
              to="/institute/add-student"
              className="add-btn"
            >
              <FiPlus />
              Add Student
            </Link>

          </div>
        </div>
      </div>
      <Container fluid >
        <div className="staff-card">
          <Offcanvas
            show={showFilter}
            onHide={() => setShowFilter(false)}
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Filters</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
              {/* <Form.Group className="mb-3">
              <Form.Label>Items Per Page</Form.Label>
              <Form.Select
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Form.Select>
            </Form.Group> */}

              <Form.Group className="mb-3">
                <Form.Label>Standard</Form.Label>
                <Form.Select
                  value={standardId}
                  onChange={(e) => {
                    setStandardId(e.target.value);
                    setSectionId("");
                  }}
                >
                  <option value="">Select Standard</option>
                  {standardList.map((std) => (
                    <option key={std._id} value={std._id}>
                      {std.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Section</Form.Label>
                <Form.Select
                  value={sectionId}
                  disabled={!standardId}
                  onChange={(e) => setSectionId(e.target.value)}
                >
                  <option value="">Select Section</option>
                  {standardList
                    .find((s) => s._id === standardId)
                    ?.sections?.map((sec) => (
                      <option key={sec._id} value={sec._id}>
                        {sec.name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>

              <div className="d-flex gap-2 mt-4">

                <button

                  className="w-100 btn-cancel"
                  onClick={handleClear}
                >
                  Clear
                </button>
                <button className="w-100 btn-submit" onClick={handleFilter}>
                  Apply
                </button>
              </div>

              {/* <button
              variant="outline-success"
              className="w-100 mt-3"
              onClick={handleExport}
            >
              <FiDownload /> Export
            </button> */}
            </Offcanvas.Body>
          </Offcanvas>


          <div className="table-responsive">
            <Table className="staff-table align-middle">
              <thead >
                <tr>

                  <th className="text-center">#</th>
                  <th className="text-center">Name</th>
                  <th className="text-center">Class-Sec</th>
                  <th className="text-center">Gender</th>
                  <th className="text-center">DOB</th>
                  <th className="text-center">Father's Name</th>
                  <th className="text-center">Father's Mobile</th>
                  <th className="text-center">Action</th>
                </tr >
              </thead >

              <tbody style={{ backgroundColor: "white" }}>
                {isLoading ? (
                  Array.from({ length: 8 }).map((_, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <Skeleton width={20} />
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <Skeleton
                            circle
                            width={40}
                            height={40}
                            style={{ marginRight: 10 }}
                          />
                          <Skeleton width={150} />
                        </div>
                      </td>

                      <td className="text-center">
                        <Skeleton width={90} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={70} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={90} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={140} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={120} />
                      </td>

                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Skeleton width={36} height={36} borderRadius={10} />
                          <Skeleton width={36} height={36} borderRadius={10} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : paginatedData.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center p-3">No students found!</td>
                  </tr>
                ) : (
                  paginatedData.map((s, i) => (
                    <tr key={s._id || i}>

                      <td className="text-center">{startIndex + i + 1}</td>
                      <td className="d-flex align-items-center gap-2">
                        {s.image ? (
                          <img
                            src={s.image}
                            className="avatar"
                            alt={s.name}
                          />
                        ) : (
                          <div className="avatar-placeholder">
                            {s.name?.charAt(0).toUpperCase()}
                          </div>
                        )}

                        <span>{s.name}</span>
                      </td>
                      <td className="text-center">{s.standardId?.name}-{s.sectionId?.name}</td>
                      <td className="text-center">{s.gender}</td>
                      <td className="text-center">{s.dob?.slice(0, 10)}</td>
                      <td className="text-center">{s.parentId?.fatherName}</td>
                      <td className="text-center">{s.parentId?.fatherMobileNo || "-"}</td>
                      <td className="text-center">
                        <button
                          className="edit-btn"
                          onClick={() => navigate(`/institute/edit-student/${s._id}`)}
                        >
                          <FiEdit style={{ fontSize: '15px' }} />
                        </button>
                        <button
                          className="edit-btn ms-2"
                          onClick={() => handleDeleteRow(s._id)}
                        >
                          <FiTrash2 style={{ fontSize: '15px' }} />
                        </button>


                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table >
          </div >

          <div className="d-flex justify-content-end my-3">
            <Pagination className="mb-0">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => {
                  setSearchParams({
                    page: currentPage - 1,
                    ...(filters.standardId && {
                      standardId: filters.standardId,
                    }),
                    ...(filters.sectionId && {
                      sectionId: filters.sectionId,
                    }),
                  });
                }}
              />
              {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;

                if (
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 1 && page <= currentPage + 1)
                ) {
                  return (
                    <Pagination.Item
                      key={page}
                      active={page === currentPage}
                      onClick={() => {
                        setSearchParams({
                          page,
                          ...(filters.standardId && {
                            standardId: filters.standardId,
                          }),
                          ...(filters.sectionId && {
                            sectionId: filters.sectionId,
                          }),
                        });
                      }}
                    >
                      {page}
                    </Pagination.Item>
                  );
                }

                // Left dots
                if (page === currentPage - 2) {
                  return <Pagination.Ellipsis key={`left-${page}`} disabled />;
                }

                // Right dots
                if (page === currentPage + 2) {
                  return <Pagination.Ellipsis key={`right-${page}`} disabled />;
                }

                return null;
              })}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => {
                  setSearchParams({
                    page: currentPage + 1,
                    ...(filters.standardId && {
                      standardId: filters.standardId,
                    }),
                    ...(filters.sectionId && {
                      sectionId: filters.sectionId,
                    }),
                  });
                }}
              />

            </Pagination>
          </div>
        </div>
      </Container >
    </>
  );
}
